import { useEffect, useRef, useState } from "react";

const RecaptchaV2Widget = ({ sitekey, callback, setWidgetid }) => {
  const [isRecaptchaLoaded, setIsRecaptchaLoaded] = useState(false);
  const recaptchaRef = useRef(null);

  const onRecaptchaLoad = () => {
    setIsRecaptchaLoaded(true);
  };

  useEffect(() => {
    window.onRecaptchaLoad = onRecaptchaLoad;
    if (!window.grecaptcha) {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
      script.onload = () => {};
    } else if (window.grecaptcha && window.grecaptcha.render) {
      setIsRecaptchaLoaded(true);
    }

    return () => {
      window.onRecaptchaLoad = null;
    };
  }, []);

  useEffect(() => {
    if (isRecaptchaLoaded) {
      const id = window.grecaptcha.render(recaptchaRef.current, {
        sitekey: sitekey,
        callback: callback,
      });
      setWidgetid(id);
    }
  }, [isRecaptchaLoaded]);

  return <div className="z-10" ref={recaptchaRef}></div>;
};

export default RecaptchaV2Widget;
